import React, { useEffect, useState } from 'react';

import { useLanguage } from '@/state/language/LanguageProvider';
import { toast } from 'react-hot-toast';

import { AePageHeader, AePageShell } from '@/components/assessment-engine/layout';

import {

  AE_BTN_PRIMARY,

  AE_CARD,

  AE_INPUT,

  AE_LABEL,

  AE_MUTED,

} from '@/components/assessment-engine/layout/aeTheme';

import { assessmentEngineService } from '@/services/assessmentEngineService';

import type { AeCohortSettings } from '@/types/assessmentEngine';



/** Platform admin — B1/B2/B3 cohort threshold settings. */

export const EngineSettingsPage: React.FC = () => {

  const { t } = useLanguage();

  const [settings, setSettings] = useState<AeCohortSettings>({

    b1MinResponses: 10,

    b2MinCampaigns: 2,

    b3MinOrganizations: 5,

  });

  const [loading, setLoading] = useState(true);

  const [saving, setSaving] = useState(false);



  useEffect(() => {

    assessmentEngineService

      .getCohortSettings()

      .then(setSettings)

      .catch(() => toast.error(t('assessmentEngine.settings.failedLoad')))

      .finally(() => setLoading(false));

  }, [t]);



  const save = async () => {

    setSaving(true);

    try {

      const updated = await assessmentEngineService.updateCohortSettings(settings);

      setSettings(updated);

      toast.success(t('assessmentEngine.settings.saved'));

    } catch {

      toast.error(t('assessmentEngine.settings.saveFailed'));

    } finally {

      setSaving(false);

    }

  };



  if (loading) {

    return (

      <AePageShell>

        <p className={AE_MUTED}>{t('assessmentEngine.settings.loading')}</p>

      </AePageShell>

    );

  }



  return (

    <AePageShell>

      <AePageHeader

        title={t('assessmentEngine.settings.title')}

        description={t('assessmentEngine.settings.cohortHelp')}

        breadcrumbs={[

          { label: t('assessmentEngine.breadcrumbs.engine'), to: '/assessment-engine/campaigns' },

          { label: t('assessmentEngine.settings.title') },

        ]}

      />



      <div className={`${AE_CARD} space-y-4`}>

        <div>

          <label className={AE_LABEL}>

            {t('assessmentEngine.settings.b1')}

          </label>

          <input

            type="number"

            min={1}

            className={AE_INPUT}

            value={settings.b1MinResponses}

            onChange={(e) => setSettings((s) => ({ ...s, b1MinResponses: Number(e.target.value) }))}

          />

        </div>



        <div>

          <label className={AE_LABEL}>

            {t('assessmentEngine.settings.b2')}

          </label>

          <input

            type="number"

            min={1}

            className={AE_INPUT}

            value={settings.b2MinCampaigns}

            onChange={(e) => setSettings((s) => ({ ...s, b2MinCampaigns: Number(e.target.value) }))}

          />

        </div>



        <div>

          <label className={AE_LABEL}>

            {t('assessmentEngine.settings.b3')}

          </label>

          <input

            type="number"

            min={1}

            className={AE_INPUT}

            value={settings.b3MinOrganizations}

            onChange={(e) => setSettings((s) => ({ ...s, b3MinOrganizations: Number(e.target.value) }))}

          />

        </div>



        <button type="button" disabled={saving} className={AE_BTN_PRIMARY} onClick={save}>

          {saving ? t('assessmentEngine.settings.saving') : t('assessmentEngine.settings.save')}

        </button>

      </div>

    </AePageShell>

  );

};


